import { AbstractControl, ValidatorFn } from '@angular/forms';

export const confirmarSenhaValidator: ValidatorFn = (
  control: AbstractControl,
): { [key: string]: boolean } | null => {
  if (control.value !== '' && control.value !== null) {
    const senha = control.get('senha');
    const confirmarSenha = control.get('confirmarSenha');

    if (!senha || !confirmarSenha || !senha.value || !confirmarSenha.value) {
      return null;
    }

    if (senha.value !== confirmarSenha.value) {
      senha.setErrors({ confirmarSenha: true });
      confirmarSenha.setErrors({ confirmarSenha: true });

      return { confirmarSenha: true };
    }

    senha.setErrors(null);
    confirmarSenha.setErrors(null);

    return null;
  } else return null;
};
